import { HttpInterceptor, HttpRequest, HttpHandler, HTTP_INTERCEPTORS, HttpHeaders } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, of, Subject, throwError } from "rxjs";
import { tap, catchError, switchMap } from "rxjs/operators";
import { FunctionsService } from "../functions.service";
import { TokenService } from "./token.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  tokenService: TokenService;
  functionsService: FunctionsService;
  refreshTokenInProgress = false;

  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(
    private _injector: Injector,
  ) {
  }

  addAuthHeader(request) {
    const authHeader = localStorage.getItem("accessToken");
        
    if (authHeader) {
      return request.clone({
        headers: new HttpHeaders({
          Authorization: `Bearer ${authHeader}`,
          "Content-Type": "application/json"
        })
      });
    }
   
    return request;
  }

  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      return this.tokenService.getAccessToken().pipe(
        tap((accessTokenRes) => {
          this.tokenService.setInfo(accessTokenRes);
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
          return true;
        }),
        catchError(() => {
          this.refreshTokenInProgress = false;
          this.logout();
          return of(false);
        }));
    }
  }

  logout() {
    this.functionsService.signOut();
  }

  handleResponseError(error, request?, next?) {
    if (error.status === 401) {
      if((!request) || (request && !request["url"].includes("api/login"))){
        return this.refreshToken().pipe(
          switchMap(() => {
            request = this.addAuthHeader(request);
            return next.handle(request);
          }),
          catchError(e => {
            if (e.status !== 401) {
              return this.handleResponseError(e);
            } /*else {
              this.logout();
            }*/
          })
        );
      }
    }
    else if (error.status === 403 || error.status === 500) {
      this.logout();
    }
    else if (error.status === 503) {
      // Show message
      // Redirect to the maintenance page
    }

    return throwError(error);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.tokenService = this._injector.get(TokenService);
    this.functionsService = this._injector.get(FunctionsService);
    // alert('made it to interceptor');
    // Handle response
    return next.handle(request).pipe(catchError(error => {
      return this.handleResponseError(error, request, next);
    }));
  }
}

export const AuthInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true
};